export type SelecetedItemCategoryState = string;

export const allCategoryId = 'all';

export const selectedItemCategoryReducerInitialState: SelecetedItemCategoryState =
  allCategoryId;

export enum selecetedItemCategoryActionTypes {
  SELECTED_ITEM_CATEGORY_UPDATE = 'SELECTED_ITEM_CATEGORY_UPDATE',
}

export interface SelecetedItemCategoryAction {
  type: selecetedItemCategoryActionTypes.SELECTED_ITEM_CATEGORY_UPDATE;
  payload: string;
}

const selecetedItemCategoryReducer = (
  state: SelecetedItemCategoryState,
  action: SelecetedItemCategoryAction
): SelecetedItemCategoryState => {
  switch (action.type) {
    case selecetedItemCategoryActionTypes.SELECTED_ITEM_CATEGORY_UPDATE: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

export default selecetedItemCategoryReducer;
